import { lazy, Suspense } from "react";
import CircularLoader from "../custom/circularLoader/circularLoader";
import DasboardLayout from "./dashboardLayout/dashboardLayout";

const Main = lazy(() => import("../components/applicationStatus/main"));

const ApplicationStatus = () => {
    return (
        <DasboardLayout heading="Application Status">
            <Suspense fallback={<CircularLoader/>}>
                <Main/>
            </Suspense>
        </DasboardLayout>
    )
}
export default ApplicationStatus